import React from "react";
import {
    ResponsiveContainer,
    ComposedChart,
    Line,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from "recharts";
import {barChartPropType} from "./BarChartPropTypes";
import {BarChartWrapper, CustomTooltipWrapper} from "./barChartStyles";

const CustomTooltip = ({active, payload, label}) => {
    if (active && payload && payload.length) {
        return <CustomTooltipWrapper>{`${label} : ${payload[0].value}`}</CustomTooltipWrapper>;
    }

    return null;
};

export const BarChart = ({
    barColor = "#7897AB",
    data,
    drawLine = false,
    lineColor = "#ff7300"
}: barChartPropType) => {
    return (
        <BarChartWrapper>
            <ResponsiveContainer width={"100%"} height={"100%"}>
                <ComposedChart
                    data={data}
                    margin={{
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    }}
                >
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis
                        dataKey="name"
                        scale="band"
                        tickFormatter={e => `${e.slice(0, 12)}${e.length > 12 ? "..." : ""}`}
                    />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend />
                    <Bar dataKey="value" fill={barColor} legendType="none" />
                    {drawLine && (
                        <Line
                            type="monotone"
                            dataKey="value"
                            strokeWidth="3"
                            strokeOpacity="0.5"
                            stroke={lineColor}
                            legendType="none"
                            tooltipType="none"
                        />
                    )}
                </ComposedChart>
            </ResponsiveContainer>
        </BarChartWrapper>
    );
};
